module.exports = __webpack_public_path__ + "media/svg/military-d8e9bf28.svg";